export default class MapEvent {
	constructor(el) {

		this.el = el;
		this.el.markers = document.querySelectorAll('[data-map-event-marker]');
		this.el.template = document.querySelector('[data-map-event-template]');

		const config = JSON.parse(this.el.dataset.hwcMapEvent);

		const view = L.map(this.el, {
			tap: true,
			gestureHandling: true,
		}).setView([config.center.lat, config.center.lng], 9);


		this.leafletMarkers = [];

		this.leafletCluster = L.markerClusterGroup({
			iconCreateFunction: function (cluster) {
				return L.divIcon({ html: '<span class="hwc-cluster">' + cluster.getChildCount() + '</span>' });
			}
		});

		const icon = L.icon({
			iconUrl: config.icon,
			iconSize: [32, 32],
			iconAnchor: [32 / 2, 32],
			popupAnchor: [0, 32 * -1],
		});

		this.map = {
			view: view,
			icon: icon,
		}

		L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
			attribution:
				'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
		}).addTo(this.map.view);

		this.setDepartments();
		this.setMarkers();
	}

	setMarkers() {

		this.el.markers.forEach(item => {
			this.setMarker(JSON.parse(item.dataset.mapEventMarker));
		});

		let boundingBox = new L.featureGroup(this.leafletMarkers)
		let newBounds = boundingBox.getBounds()
		newBounds._nortEast += .5;
		newBounds._southWest -= .5;

		if (newBounds.isValid()) {
			this.map.view.fitBounds(newBounds);
		}

		this.map.view.addLayer(this.leafletCluster);
	}

	setMarker(marker) {

		let leafletMarker = L.marker(
			{
				lat: marker.lat,
				lng: marker.lng
			}, {
			icon: this.map.icon
		}
		)

		this.leafletMarkers.push(leafletMarker)

		this.leafletCluster.addLayer(leafletMarker);

		this.setPopup(marker, leafletMarker);
	}

	getPopup(marker) {

		let html_popup = document.importNode(this.el.template.content, true);

		let title = html_popup.querySelector('[data-map-event-template-title]');
		if (marker.title && title) {
			title.textContent = marker.title;
		} else {
			title.remove()
		}

		let date = html_popup.querySelector('[data-map-event-template-date]');
		if (marker.day && date) {
			date.textContent = marker.day;
		} else {
			date.remove()
		}

		let thumb = html_popup.querySelector('[data-map-event-template-thumb]');
		if (marker.thumbnail && thumb) {
			thumb.src = marker.thumbnail;
			thumb.alt = marker.title;
		} else {
			thumb.remove()
		}

		let address = html_popup.querySelector('[data-map-event-template-address]');
		if (marker.address && address) {
			address.textContent = marker.address;
		} else {
			address.remove()
		}

		let link = html_popup.querySelector('[data-map-event-template-link]');
		if (marker.link && link && marker.title) {
			link.setAttribute('href', marker.link);
			link.setAttribute('title', marker.title);
		} else {
			link.remove();
		}

		return html_popup;

	}

	setPopup(marker, leafletMarker) {

		const html = this.getPopup(marker);
		let popupWrapper = document.createElement('div');
		popupWrapper.appendChild(html);
		leafletMarker.bindPopup(popupWrapper.innerHTML);

	}

	setDepartments() {
		fetch('wp-content/themes/sea73-theme/dist/json/savoie-departments.geojson')
			.then(r => r.json())
			.then(data => {
				// World outer ring (counterclockwise)
				const world = [
					[-90, -180], [-90, 180],
					[90, 180], [90, -180],
					[-90, -180]
				];

				// Extract department holes (flip [lng,lat] → [lat,lng])
				const holes = [];
				data.features.forEach(feature => {
					const coords = feature.geometry.coordinates;
					const type = feature.geometry.type;

					if (type === 'Polygon') {
						holes.push(coords[0].map(c => [c[1], c[0]]));
					} else if (type === 'MultiPolygon') {
						coords.forEach(polygon => {
							holes.push(polygon[0].map(c => [c[1], c[0]]));
						});
					}
				});

				// Build mask: world polygon with department holes
				const maskCoords = [
					world.map(c => [c[0], c[1]]),
					...holes
				];

				L.polygon(maskCoords, {
					color: 'none',
					fillColor: '#000',
					fillOpacity: 0.5,
					interactive: false
				}).addTo(this.map.view);
			});
	}

	addDeptLayer(data) {
		L.geoJSON(data, {
			style: {
				color: '#ff6b35',
				weight: 2,
				fill: false
			}
		}).addTo(this.map.view);
	}
}
